﻿import 'jquery-countdown';
function createCountdown(item) {
    item.countdown(item.data('countdown-date'), function (event) {
        item.find('[data-countdown-days]').text(event.strftime('%D'));
        item.find('[data-countdown-hours]').text(event.strftime('%H'));
        item.find('[data-countdown-minutes]').text(event.strftime('%M'));
        item.find('[data-countdown-seconds]').text(event.strftime('%S'));
    });
}

export function setupCountdowns() {
    $('[data-countdown-date]').each(function () {
        createCountdown($(this));
    });
}
